// extracted by extract-css-chunks-webpack-plugin
module.exports = {"navigation_box":"navigation_box-3b8WM0QB","navigation":"navigation-7Gukt5kS clearfix"};